<script>
    import Button from './Button.svelte';
    import PageSection from './PageSection.svelte';
    import Prose from './Prose.svelte';
    import H2 from './H2.svelte';
    import { logEvent } from './utils/logs';
    import { detectUserCountry, getAmazonBookUrl } from './utils/amazon-geo.js';
    import Card from './Card.svelte';
    import { onMount } from 'svelte';
    import { img_cdn, img_cdn_srcset, img_responsive_sizes, img_responsive_srcset } from './utils/image';

    let className = '';
    export { className as class };
    /** @type {Book} */
    export let book;

    let amazon_url = getAmazonBookUrl(book.asin);

    onMount(()=>{
        amazon_url = getAmazonBookUrl(book.asin)
    })

    const handle_buy_amazon = () => {
        logEvent(`book-buy-amazon-${book.asin}`);
        window.open(amazon_url, '_blank');
    };

    const image_options =  {
        xs: {w:277, h:277 },
        sm: {w:574, h:574 },
        md: {w:415, h:415 },
        lg: {w:453, h:453 },
    }

</script>

<PageSection
    class="
        {className}
    "
>
    <Card
        p_xl
        class="flex flex-col lg:flex-row
        items-start
        gap-8 lg:gap-12"
    >
        <div class="flex-shrink-0 w-full lg:w-6/12 xl:w-5/12 2xl:w-4/12">
            <img
                src={img_cdn(book.cover_image, {w:222, h:222 })}
                srcset="{img_responsive_srcset(book.cover_image, image_options)}"
                sizes="{img_responsive_sizes(image_options)}"
                loading="lazy"
                alt="{book.title} book cover"
                class="w-full h-auto aspect-square rounded-lg shadow-lg"
            />
        </div>

        <div class="flex-1">
            <H2 lg class="mb-4"><a href="{amazon_url}" class="link" target="_blank">{book.title}</a></H2>
            <Prose lg>
                {@html book.content}
                <p>
                    <Button primary on:click={handle_buy_amazon}
                        >Buy on Amazon</Button
                    >
                </p>
            </Prose>
        </div>
    </Card>
</PageSection>

<style>
</style>


